import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import DTAArticle from "@dta/components/DTAArticle";
import DTADescription from "@dta/components/DTADescription";
import DTAFooter from "@dta/components/DTAFooterComponents/DTAFooter";
import DTANominationsDescription from "@dta/components/DTANominationsDescription";
import DTAOrganiserDetails from "@dta/components/DTAOrganiserDetails";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_DTA_LABEL,
  EVENTS_AWARDS_DTA_PATH,
} from "@events-awards/utils/constants";
import {
  AwardType,
  EventsAwardsHomePageContextData,
} from "@events-awards/utils/types";
import { useDetectAdBlock } from "adblock-detect-react";

/**
 * Component to render DTA page
 */
const EventsAwardsDTAPageContent = ({
  articleProps,
}: EventsAwardsHomePageContextData): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  return (
    <div
      className="w-full"
      data-testid="events-awards-dta-page-content-component"
    >
      <AdSettings
        adNames={["lb1", "prestitial", "catfish"]}
        path={EVENTS_AWARDS_DTA_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Design AI and Tech"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title="Design AI and Tech Latest News & Headlines - THE BUSINESS TIMES"
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_DTA_LABEL} - Find ${EVENTS_AWARDS_DTA_LABEL} News & Headlines, insight and analysis in Singapore, Asia-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_DTA_PATH}
      />

      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.DATA} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <DTAArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <DTADescription />

      <div className="mt-1 bg-gray-150 py-8 md:px-3 md:px-6 lg:px-0">
        <Container rootClassName="flex flex-row justify-center items-center">
          <DTANominationsDescription />
        </Container>
      </div>

      <DTAOrganiserDetails />

      <DTAFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsDTAPageContent;
